import { AlertColor } from '@mui/material/Alert'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'
import { IOnboardSocialChannelPayload } from '../../types/contentCreatorTypes'

export interface IContentCreatorSlice {
  status: string
  shouldOpen: boolean
  message: string | undefined
  severity: AlertColor | undefined
  isContentCreatorBannerShow: boolean
  isInfluencerModalOpen: boolean
  isInfluencerOnboardModalOpen: boolean
  onboardDescribeYourselfDetail: string
  onboardSocialChannelsDetail: IOnboardSocialChannelPayload[] | undefined
  onboardContentNicheDetail: string[]
  currentTab: string
  isInfluencer: boolean
}

const initialState: IContentCreatorSlice = {
  status: 'idle',
  shouldOpen: false,
  message: undefined,
  severity: undefined,
  isContentCreatorBannerShow: false,
  isInfluencerModalOpen: false,
  isInfluencerOnboardModalOpen: false,
  onboardDescribeYourselfDetail: '',
  onboardSocialChannelsDetail: undefined,
  onboardContentNicheDetail: [],
  currentTab: 'explore-campaigns',
  isInfluencer: false,
}

export const contentCreatorSlice = createSlice({
  name: 'contentCreator',
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.shouldOpen = action.payload
    },
    setContentCreatorBannerShow: (state, action: PayloadAction<boolean>) => {
      state.isContentCreatorBannerShow = action.payload
    },
    setIsInfluencerModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isInfluencerModalOpen = action.payload
    },
    setIsInfluencerOnboardModalOpen: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isInfluencerOnboardModalOpen = action.payload
    },
    setOnboardDescribeYourselfDetail: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.onboardDescribeYourselfDetail = action.payload
    },
    setOnboardSocialChannelsDetail: (
      state,
      action: PayloadAction<IOnboardSocialChannelPayload[]>,
    ) => {
      state.onboardSocialChannelsDetail = action.payload
    },
    setOnboardContentNicheDetail: (state, action: PayloadAction<string[]>) => {
      state.onboardContentNicheDetail = action.payload
    },
    setCurrentTab: (state, action: PayloadAction<string>) => {
      state.currentTab = action.payload
    },

    clearData: () => initialState,
  },
})

export const selectIsLoading = (state: RootState): boolean =>
  state.contentCreator.status === 'loading'
export const selectShouldOpen = (state: RootState): boolean =>
  state.contentCreator.shouldOpen
export const selectMessage = (state: RootState): string | undefined =>
  state.contentCreator.message
export const selectSeverity = (state: RootState): AlertColor | undefined =>
  state.contentCreator.severity
export const selectIsContentCreatorBannerShow = (state: RootState): boolean =>
  state.contentCreator.isContentCreatorBannerShow
export const selectIsInfluencerModalOpen = (state: RootState): boolean =>
  state.contentCreator.isInfluencerModalOpen
export const selectIsInfluencerOnboardModalOpen = (state: RootState): boolean =>
  state.contentCreator.isInfluencerOnboardModalOpen
export const selectOnboardDescribeYourselfDetail = (state: RootState): string =>
  state.contentCreator.onboardDescribeYourselfDetail
export const selectOnboardSocialChannelsDetail = (
  state: RootState,
): IOnboardSocialChannelPayload[] | undefined =>
  state.contentCreator.onboardSocialChannelsDetail
export const selectOnboardContentNicheDetail = (state: RootState): string[] =>
  state.contentCreator.onboardContentNicheDetail
export const selectCurrentTab = (state: RootState): string =>
  state.contentCreator.currentTab
export const selectIsInfluencer = (state: RootState): boolean =>
  state.contentCreator.isInfluencer

export const {
  setOpen,
  clearData,
  setContentCreatorBannerShow,
  setIsInfluencerModalOpen,
  setIsInfluencerOnboardModalOpen,
  setOnboardDescribeYourselfDetail,
  setOnboardSocialChannelsDetail,
  setOnboardContentNicheDetail,
  setCurrentTab,
} = contentCreatorSlice.actions

export default contentCreatorSlice.reducer
